(function () {
  var preloader = document.getElementById('auroraPreloader');
  if (!preloader) return;
  var minTime = 500;
  var start = Date.now();
  var hidden = false;
  function hide() {
    if (hidden) return;
    hidden = true;
    var wait = Math.max(0, minTime - (Date.now() - start));
    setTimeout(function () {
      preloader.classList.add('is-done');
      setTimeout(function () { preloader.remove(); }, 600);
    }, wait);
  }
  if (document.readyState === 'complete') {
    hide();
  } else {
    window.addEventListener('load', hide);
    setTimeout(hide, 3000);
  }
})();

(function () {
  document.querySelectorAll('[data-aurora-nav-toggle]').forEach(function (toggle) {
    var links = toggle.parentElement.querySelector('[data-aurora-nav-links]');
    if (!links) return;
    toggle.addEventListener('click', function () {
      var open = links.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    links.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { links.classList.remove('is-open'); });
    });
  });
})();

(function () {
  var result = document.querySelector('[data-aurora-form-result]');
  if (!result) return;
  result.scrollIntoView({ block: 'center', behavior: 'smooth' });
  result.focus({ preventScroll: true });
})();

(function () {
  document.querySelectorAll('[data-aurora-canvas]').forEach(function (canvas) {
    var ctx = canvas.getContext('2d');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w, h;

    function resize() {
      w = canvas.clientWidth;
      h = canvas.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    window.addEventListener('resize', resize);
    resize();

    var bands = [
      { color: '#22b573', amp: 0.10, freq: 1.4, speed: 0.55, yBase: 0.30, width: 34 },
      { color: '#1ec9c0', amp: 0.13, freq: 1.1, speed: 0.4,  yBase: 0.40, width: 44 },
      { color: '#3aa8e8', amp: 0.09, freq: 1.7, speed: 0.6,  yBase: 0.22, width: 30 },
      { color: '#3a72c4', amp: 0.12, freq: 0.9, speed: 0.32, yBase: 0.48, width: 50 }
    ];

    function draw(t) {
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';
      bands.forEach(function (b, i) {
        var grad = ctx.createLinearGradient(0, 0, w, 0);
        grad.addColorStop(0, 'rgba(0,0,0,0)');
        grad.addColorStop(0.5, b.color);
        grad.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.strokeStyle = grad;
        ctx.lineWidth = b.width;
        ctx.globalAlpha = 0.22;
        ctx.beginPath();
        for (var x = 0; x <= w; x += 6) {
          var y = h * b.yBase + Math.sin(x * 0.004 * b.freq + t * b.speed + i) * h * b.amp
                 + Math.sin(x * 0.0016 * b.freq - t * b.speed * 0.6) * h * b.amp * 0.4;
          if (x === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
        }
        ctx.stroke();
      });
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
    }

    if (reduced) {
      draw(0);
      return;
    }

    function loop(now) {
      draw(now * 0.00035);
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  });
})();
